<template>
	<nav class="main-nav">
	  <div class="nav-logo" @click="$router.push('home')">
		<img class="logo-image" src="../assets/logo.png" alt="Vedic Astrology Report" />
	  </div>
	</nav>
</template>
  

<script>
export default {
	
	data() {
		return {
		}
	},
	created() {
	},
	methods: {
	}
}
</script>

<style scoped>

.main-nav {
  width: 100%;
  height: 75px;
  background-color: #344E41;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 2px 2px 2px 2px #A3B18A;
  z-index: 999;
}

.nav-logo {
  cursor: pointer;
  z-index: 2; /* stay above background */
}

.logo-image {
  height: auto;
  width: 297px;
}

.router-link-exact-active .icon-button {
  background-color: #FF9F1C;
  color: white;
}

@media (max-width: 768px) {
  .logo-image {
    height: 70px;
  }

}

@media print {
  .main-nav {
    display: none;
  }
}

</style>
